/*
 * jQuery Form Ajax Filter plugin
 */
;(function($, $win) {
	'use strict';

	function FormAjaxLoader(options) {
		this.options = $.extend({
			holder: null,
			form: 'form',
			newHolderSelector: '.ajax-content-holder',
			busyClass: 'is-busy',
			preAppendClass: 'new-item',
			pagerLink: 'a.page',
			changeMode: false,
			inputMode: false,
			requestDelay: 200
		}, options);
		this.init();
	}

	FormAjaxLoader.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},

		findElements: function() {
			this.$holder = $(this.options.holder);
			this.$form = this.$holder.find(this.options.form);
			this.$newHolderTarget = this.$holder.find(this.options.newHolderSelector);
			this.options.changeMode = this.$form.attr('data-filter-mode') && this.$form.attr('data-filter-mode') === 'submit' ? false : this.options.changeMode;
		},

		attachEvents: function() {
			var self = this;

			this.$form.on('submit.SubmitLoader', function(e) { self.onSubmitHandler(e); });
			this.$form.on('reset.ChangeLoader', function(e) { self.onChangeHandler(e); });

			if (this.options.changeMode) {
				this.$form.on('change.ChangeLoader', function(e) { self.onChangeHandler(e); });
			}

			if (this.options.inputMode) {
				this.$form.on('input.ChangeLoader', function(e) { self.onChangeHandler(e); });
			}

			this.$holder.on('click.PagingLoader', self.options.pagerLink, function(e) { self.onClickHandler(e); });
		},

		onSubmitHandler: function(e) {
			e.preventDefault();

			clearTimeout(this.sendTimer);

			this.sendData();
		},

		onChangeHandler: function(e) {
			var self = this;
			var $input = jQuery(e.target);


			if (e.type === 'change' && ($input.is(':checkbox') || $input.is('radio') || $input.is('select'))) {
				this.sendTimer = setTimeout(function() {
					self.sendData();
				}, this.options.requestDelay || 200);
			}

			if (e.type === 'input') {
				this.sendTimer = setTimeout(function() {
					self.sendData();
				}, this.options.requestDelay || 200);
			}
		},

		onClickHandler: function(e) {
			e.preventDefault();

			var data = {url: jQuery(e.currentTarget).attr('href'), data: ''};
			this.loadInclude(data);
		},

		sendData: function() {
			var data = {url: this.$form.attr('data-action') || this.$form.attr('action'), data: '&' + this.$form.serialize()};
			this.loadInclude(data);
		},

		loadInclude: function(data) {

			var self = this;

			// abort previous request if not completed
			if(this.acXHR && typeof this.acXHR.abort === 'function') this.acXHR.abort();

			this.toggleBusyMode(true);

			this.acXHR = $.ajax({
				url: data.url,
				type:'get',
				data: 'ajax=1' + data.data,
				dataType:'text',
				success:function(source) {
					self.successHandler(source);
				},
				error:function(e) {
					if (window.console) console.log('ajax error! status ' + e.status);

					self.$holder.trigger('FormAjaxLoader/error');
					self.toggleBusyMode(false);
				}
			});
		},

		successHandler: function(include) {
			var $tmpDiv = jQuery('<div>').html(include);

			this.refreshItems($tmpDiv.children());
		},

		refreshItems: function($newContent) {
			var self = this;

			this.$newHolderTarget.empty().append($newContent.addClass(this.options.preAppendClass));

			this.$holder.trigger('FormAjaxLoader/appended', {$newContent: $newContent});

			setTimeout(function() { // need this timeout coz need some time for css preAppendClass applied to the new items
				$newContent.removeClass(self.options.preAppendClass);

				self.$holder.trigger('FormAjaxLoader/loaded', {$newContent: $newContent});
				self.toggleBusyMode(false);
			}, 100);

			if (window.picturefill) {
				window.picturefill();
			}
		},

		toggleBusyMode: function(state) {
			this.$holder.toggleClass(this.options.busyClass, state);
			this.isBusy = state;
		},


		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	// jquery plugin
	$.fn.formAjaxLoader = function(opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		return this.each(function() {
			var $holder = jQuery(this);
			var instance = $holder.data('FormAjaxLoader');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				$holder.data('FormAjaxLoader', new FormAjaxLoader($.extend({
					holder: this
				}, opt)));
			} else if (typeof method === 'string' && instance) {
				if (typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};
}(jQuery, jQuery(window)));

